import React from 'react';

// Styles are inline so this stays a single file — it is small, and it is used
// from both the station rows and the detail header.
const BUTTON_STYLE = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
    background: 'none',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    lineHeight: 0,
};

// Also used on its own wherever a heart is decoration rather than a control.
export const HeartSvg = ({ filled = false, size = 22, color = '#00aa74' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            d="M12.62 20.81c-.34.12-.9.12-1.24 0C8.48 19.82 2 15.69 2 8.69 2 5.6 4.49 3.1 7.56 3.1c1.82 0 3.43.88 4.44 2.24a5.53 5.53 0 0 1 4.44-2.24C19.51 3.1 22 5.6 22 8.69c0 7-6.48 11.13-9.38 12.12Z"
            fill={filled ? color : 'none'}
            stroke={color}
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const HeartToggle = ({
    isFavourite = false,
    onToggle,
    stationName,
    size = 22,
    color = '#00aa74',
    style,
}) => {
    const handleClick = (event) => {
        // Station rows and cards are themselves clickable — the heart must
        // never take the user to the detail screen.
        event.stopPropagation();
        if (onToggle) onToggle();
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            style={{ ...BUTTON_STYLE, ...style }}
            aria-pressed={isFavourite}
            aria-label={`${isFavourite ? 'Remove' : 'Add'} ${
                stationName || 'this station'
            } ${isFavourite ? 'from' : 'to'} favourites`}
        >
            <HeartSvg filled={isFavourite} size={size} color={color} />
        </button>
    );
};

export default HeartToggle;
